export const getUser = state => state.user;
export const getUserProfile = state => state.user?.profile;
